import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getItemSelecter } from '../redux/slice/cartSlice';
import { NavLink } from 'react-router-dom';


const Addcartitem = () => {

  const seletedItems = useSelector(getItemSelecter)
  const items = [...seletedItems]


  const totalAmount = items.reduce((a, b) => a + b.price, 0)


  return (

    <div className='container-fluid'>
      <div className='row'>
        <div className='col-7 card_container' style={{
          boxShadow: ' rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px',
          borderRadius: '.0',
          padding: '2rem',
          backgroundColor: 'black'
        }}>
          {
            items.map((ele) => {
              return (
                <div className='row row3' style={{ padding: '1rem', borderRadius: '0.7rem', backgroundColor: 'white' }}>
                  <div className='col-4 mt-3'>
                    <img src={ele.img}
                      className='img-fluid' />

                  </div>
                  <div className='col-4 product_section '>
                    <p className='name' >{ele.name}</p>
                    <p className='color'>{ele.color}</p>
                    <p className='price'>₹{ele.price}</p>

                  </div>
                  <div className='col-4 Buy_section '>
                    <button className=' btn btn-primary'>
                      <NavLink to='/cart/buy' style={{ color: 'white', textDecoration: 'none' }} >Buy Now</NavLink>
                    </button>
                  </div>
                </div>
              )
            })
          }

        </div>

        <div className='col-5 ' style={{
          width: '30%',
          backgroundColor: 'yellow',
          marginRight: '2rem',
          borderRadius: '.7rem',
          boxShadow: ' rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px'


        }}>
          <p className='quantity'>Number of item  : {seletedItems.length} </p>
          <p className='total_price'> Total price : ₹{totalAmount} </p>

        </div>

      </div>
    </div >
  )

}

export default Addcartitem;